var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          staticClass: "setting-form",
          attrs: {
            model: _vm.formConfig,
            size: "mini",
            "label-position": "left",
            "label-width": "120px",
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-collapse",
            {
              staticClass: "setting-collapse",
              model: {
                value: _vm.formActiveCollapseNames,
                callback: function ($$v) {
                  _vm.formActiveCollapseNames = $$v
                },
                expression: "formActiveCollapseNames",
              },
            },
            [
              _c(
                "el-collapse-item",
                {
                  attrs: {
                    name: "1",
                    title: _vm.i18nt("designer.setting.basicSetting"),
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.i18nt("designer.setting.formSize") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.formConfig.size,
                            callback: function ($$v) {
                              _vm.$set(_vm.formConfig, "size", $$v)
                            },
                            expression: "formConfig.size",
                          },
                        },
                        _vm._l(_vm.formSizes, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.i18nt("designer.setting.labelPosition"),
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "radio-group-custom",
                          model: {
                            value: _vm.formConfig.labelPosition,
                            callback: function ($$v) {
                              _vm.$set(_vm.formConfig, "labelPosition", $$v)
                            },
                            expression: "formConfig.labelPosition",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "left" } }, [
                            _vm._v(
                              _vm._s(_vm.i18nt("designer.setting.leftPosition"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("el-radio-button", { attrs: { label: "top" } }, [
                            _vm._v(
                              _vm._s(_vm.i18nt("designer.setting.topPosition"))
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.i18nt("designer.setting.labelAlign"),
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "radio-group-custom",
                          model: {
                            value: _vm.formConfig.labelAlign,
                            callback: function ($$v) {
                              _vm.$set(_vm.formConfig, "labelAlign", $$v)
                            },
                            expression: "formConfig.labelAlign",
                          },
                        },
                        [
                          _c(
                            "el-radio-button",
                            { attrs: { label: "label-left-align" } },
                            [
                              _vm._v(
                                _vm._s(_vm.i18nt("designer.setting.leftAlign"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "label-center-align" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.i18nt("designer.setting.centerAlign")
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "label-right-align" } },
                            [
                              _vm._v(
                                _vm._s(_vm.i18nt("designer.setting.rightAlign"))
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.i18nt("designer.setting.labelWidth"),
                      },
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { min: 0 },
                        model: {
                          value: _vm.formConfig.labelWidth,
                          callback: function ($$v) {
                            _vm.$set(_vm.formConfig, "labelWidth", $$v)
                          },
                          expression: "formConfig.labelWidth",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "0" } },
                    [
                      _c("el-divider", { staticClass: "custom-divider" }, [
                        _vm._v(
                          _vm._s(_vm.i18nt("designer.setting.formSFCSetting"))
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.i18nt("designer.setting.formModelName"),
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.formConfig.modelName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formConfig, "modelName", $$v)
                          },
                          expression: "formConfig.modelName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.i18nt("designer.setting.formRefName"),
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.formConfig.refName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formConfig, "refName", $$v)
                          },
                          expression: "formConfig.refName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.i18nt("designer.setting.formRulesName"),
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.formConfig.rulesName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formConfig, "rulesName", $$v)
                          },
                          expression: "formConfig.rulesName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showFormEventDialogFlag
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialog-drag", rawName: "v-dialog-drag" }],
              staticClass: "small-padding-dialog",
              attrs: {
                title: _vm.i18nt("designer.setting.editFormEventHandler"),
                visible: _vm.showFormEventDialogFlag,
                "show-close": true,
                "append-to-body": "",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "destroy-on-close": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showFormEventDialogFlag = $event
                },
              },
            },
            [
              _c("el-alert", {
                attrs: {
                  type: "info",
                  closable: false,
                  title: "form." + _vm.eventParamsMap[_vm.curEventName],
                },
              }),
              _vm._v(" "),
              _c("el-alert", {
                attrs: { type: "info", closable: false, title: "}" },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.showFormEventDialogFlag = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveFormEventHandler },
                    },
                    [_vm._v(" " + _vm._s(_vm.i18nt("designer.hint.confirm")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showEditFormCssDialogFlag
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialog-drag", rawName: "v-dialog-drag" }],
              staticClass: "small-padding-dialog",
              attrs: {
                title: _vm.i18nt("designer.setting.formCss"),
                visible: _vm.showEditFormCssDialogFlag,
                "show-close": true,
                "append-to-body": "",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "destroy-on-close": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showEditFormCssDialogFlag = $event
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.showEditFormCssDialogFlag = false
                        },
                      },
                    },
                    [_vm._v(" 取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveFormCss },
                    },
                    [_vm._v(" " + _vm._s(_vm.i18nt("designer.hint.confirm")))]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }